import React from 'react';
import { Button, ModalHeader } from '../../components/Bootstrap';
const completedIcon = require('./completedIcon.svg');

interface ConfirmationProps {
  venueName: string;
  isLoggedIn: boolean;
  venueId: string;
}

const ActionButton = ({ isLoggedIn, venueId }: { isLoggedIn: boolean; venueId: string }) => {
  if (isLoggedIn) {
    return (
      <Button
        type='submit'
        color='primary'
        className='btn--rounded-padded mt-4 mb-3'
        href={`/venue/${venueId}/dashboard`}
      >
        Go to home
      </Button>
    );
  } else {
    return (
      <Button type='submit' color='primary' className='btn--rounded-padded mt-4 mb-3' href='/'>
        Login
      </Button>
    );
  }
};

export class Confirmation extends React.Component<ConfirmationProps, {}> {
  render() {
    return (
      <div>
        <ModalHeader className='justify-content-center'>Venue Created</ModalHeader>
        <div className='text-center'>
          <img src={completedIcon} />
          <p className='completed-copy'>
            Welcome! {this.props.venueName} is officially a part of the Noble family. Let’s start customizing your
            venue.
          </p>
          <ActionButton venueId={this.props.venueId} isLoggedIn={this.props.isLoggedIn} />
        </div>
      </div>
    );
  }
}
